import Loader from "components/Spinners/Loader";

export const LoadingSpinner = () => (
  <div className="flex justify-center h-screen items-center w-full">
    <Loader
      filledColor="#2b364b"
      className="!h-[60px] !flex !items-center !text-center !justify-center"
    />
  </div>
);